// import React, { useState } from "react";
// import Swal from "sweetalert2";
// import { FineService } from "../services/addNewFineService";

// const AddFineModal = ({ showModal, setShowModal, users, fetchData }) => {
//   const defaultFineState = {
//     users: [],
//     fineType: "",
//     amount: "",
//     date: new Date().toISOString().split("T")[0],
//   };

//   const [newFine, setNewFine] = useState(defaultFineState);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewFine((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCheckboxChange = (e) => {
//     const userId = e.target.value;
//     setNewFine((prev) => ({
//       ...prev,
//       users: e.target.checked
//         ? [...prev.users, userId]
//         : prev.users.filter((id) => id !== userId),
//     }));
//   };

//   const handleSubmitFine = async (e) => {
//     e.preventDefault();
//     if (newFine.users.length === 0) {
//       return Swal.fire("Warning", "Select at least one user.", "warning");
//     }

//     setIsSubmitting(true);
//     try {
//       const { users100, users200 } = await FineService.addFineRulewise(
//         newFine.users,
//         newFine.fineType,
//         newFine.amount,
//         newFine.date,
//         users
//       );

//       const htmlMsg = `
//         <div style="margin-bottom:8px;">
//           <b>${users100.length} user(s) will get Rs. ${newFine.amount} fine:</b><br/>
//           ${users100.map((name) => `<span style='color:#0d6efd;font-weight:bold;'>${name}</span>`).join(", ") || "<span style='color:gray'>None</span>"}
//         </div>
//         <div>
//           <b>${users200.length} user(s) will get Rs. ${parseFloat(newFine.amount) * 2} fine (repeated this week):</b><br/>
//           ${users200.map((name) => `<span style='color:#dc3545;font-weight:bold;'>${name}</span>`).join(", ") || "<span style='color:gray'>None</span>"}
//         </div>
//       `;

//       const result = await Swal.fire({
//         title: `Add a ${newFine.fineType} fine to ${newFine.users.length} user(s)?`,
//         html: htmlMsg,
//         icon: "question",
//         showCancelButton: true,
//         confirmButtonText: "Yes, add fine",
//         cancelButtonText: "Cancel",
//       });

//       if (!result.isConfirmed) return;

//       await fetchData();
//       setShowModal(false);
//       setNewFine(defaultFineState);
//     } catch (err) {
//       Swal.fire("Error", err.message, "error");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!showModal) return null;

//   return (
//     <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <form onSubmit={handleSubmitFine}>
//             <div className="modal-header">
//               <h5 className="modal-title"><i className="bi bi-coin me-2"></i>Add New Fine</h5>
//               <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
//             </div>

//             <div className="modal-body">
//               <div className="mb-3">
//                 <label className="form-label">Fine Type</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="fineType"
//                   value={newFine.fineType}
//                   onChange={handleInputChange}
//                   placeholder="Enter fine type"
//                   required
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Amount (PKR)</label>
//                 <div className="input-group">
//                   <span className="input-group-text">Rs.</span>
//                   <input
//                     type="number"
//                     className="form-control"
//                     name="amount"
//                     value={newFine.amount}
//                     onChange={handleInputChange}
//                     placeholder="Enter amount"
//                     min="0"
//                     step="0.01"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   name="date"
//                   value={newFine.date}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Select Users</label>
//                 <div className="card">
//                   <div className="card-body p-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
//                     {users.length > 0 ? (
//                       users.map((user) => (
//                         <div key={user.id} className="form-check">
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             id={`user-${user.id}`}
//                             value={user.id}
//                             checked={newFine.users.includes(user.id)}
//                             onChange={handleCheckboxChange}
//                           />
//                           <label className="form-check-label" htmlFor={`user-${user.id}`}>
//                             {user.userName} {user.email && `- ${user.email}`}
//                           </label>
//                         </div>
//                       ))
//                     ) : (
//                       <p className="text-muted mb-0">No users found</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="form-text">Selected: {newFine.users.length} user(s)</div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={isSubmitting || newFine.users.length === 0 || !newFine.amount || !newFine.fineType}
//               >
//                 {isSubmitting ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm me-2" role="status"></span>
//                     Please wait...
//                   </>
//                 ) : (
//                   "Add Fine"
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddFineModal;











// import React, { useState } from "react"; 
// import Swal from "sweetalert2";
// import { FineService } from "../services/addNewFineService";
// import { db } from "../firebase";
// import { doc, getDoc } from "firebase/firestore";

// const AddFineModal = ({ showModal, setShowModal, users, fetchData }) => {
//   const defaultFineState = {
//     users: [],
//     fineType: "",
//     amount: "",
//     date: new Date().toISOString().split("T")[0],
//   };

//   const [newFine, setNewFine] = useState(defaultFineState);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewFine((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCheckboxChange = (e) => {
//     const userId = e.target.value;
//     setNewFine((prev) => ({
//       ...prev,
//       users: e.target.checked
//         ? [...prev.users, userId]
//         : prev.users.filter((id) => id !== userId),
//     }));
//   };

//   const handleSubmitFine = async (e) => {
//   e.preventDefault();
//   if (newFine.users.length === 0) {
//     return Swal.fire("Warning", "Select at least one user.", "warning");
//   }

//   setIsSubmitting(true);
//   try {
//     // Check the allowDisallow flag
//     const docRef = doc(db, "appSetupAction", "1");
//     const docSnap = await getDoc(docRef);
//     const allowDisallow = docSnap.exists() ? docSnap.data().allowDisallow : false;

//     let users100 = [];
//     let users200 = [];

//     if (allowDisallow) {
//       // Rulewise ON
//       const result = await FineService.addFineRulewise(
//         newFine.users,
//         newFine.fineType,
//         newFine.amount,
//         newFine.date,
//         users
//       );
//       users100 = result.users100;
//       users200 = result.users200;
//     } else {
//       // Rulewise OFF
//       const result = await FineService.addFineNormal(
//         newFine.users,
//         newFine.fineType,
//         newFine.amount,
//         newFine.date
//       );
//       users100 = result.users100;
//       users200 = result.users200; // will be empty
//     }

//     // Determine user names for alerts
//     const users100Names = users100.map(id => users.find(u => u.id === id)?.userName || id);
//     const users200Names = users200.map(id => users.find(u => u.id === id)?.userName || id);

//     // Build HTML
//     const htmlMsg = `
//       <div style="margin-bottom:8px;">
//         <b>${users100Names.length} user(s) will get Rs. ${newFine.amount} fine:</b><br/>
//         ${users100Names.map(name => `<span style='color:#0d6efd;font-weight:bold;'>${name}</span>`).join(", ") || "<span style='color:gray'>None</span>"}
//       </div>
//       <div>
//         <b>${users200Names.length} user(s) will get Rs. ${parseFloat(newFine.amount) * 2} fine (repeated this week):</b><br/>
//         ${users200Names.map(name => `<span style='color:#dc3545;font-weight:bold;'>${name}</span>`).join(", ") || "<span style='color:gray'>None</span>"}
//       </div>
//     `;

//     const confirmResult = await Swal.fire({
//       title: `Add a ${newFine.fineType} fine to ${newFine.users.length} user(s)?`,
//       html: htmlMsg,
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, add fine",
//       cancelButtonText: "Cancel",
//     });

//     if (!confirmResult.isConfirmed) return;

//     await fetchData();
//     setShowModal(false);
//     setNewFine({
//       users: [],
//       fineType: "",
//       amount: "",
//       date: new Date().toISOString().split("T")[0],
//     });
//   } catch (err) {
//     Swal.fire("Error", err.message, "error");
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   if (!showModal) return null;

//   return (
//     <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <form onSubmit={handleSubmitFine}>
//             <div className="modal-header">
//               <h5 className="modal-title"><i className="bi bi-coin me-2"></i>Add New Fine</h5>
//               <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
//             </div>

//             <div className="modal-body">
//               <div className="mb-3">
//                 <label className="form-label">Fine Type</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="fineType"
//                   value={newFine.fineType}
//                   onChange={handleInputChange}
//                   placeholder="Enter fine type"
//                   required
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Amount (PKR)</label>
//                 <div className="input-group">
//                   <span className="input-group-text">Rs.</span>
//                   <input
//                     type="number"
//                     className="form-control"
//                     name="amount"
//                     value={newFine.amount}
//                     onChange={handleInputChange}
//                     placeholder="Enter amount"
//                     min="0"
//                     step="0.01"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   name="date"
//                   value={newFine.date}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Select Users</label>
//                 <div className="card">
//                   <div className="card-body p-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
//                     {users.length > 0 ? (
//                       users.map((user) => (
//                         <div key={user.id} className="form-check">
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             id={`user-${user.id}`}
//                             value={user.id}
//                             checked={newFine.users.includes(user.id)}
//                             onChange={handleCheckboxChange}
//                           />
//                           <label className="form-check-label" htmlFor={`user-${user.id}`}>
//                             {user.userName} {user.email && `- ${user.email}`}
//                           </label>
//                         </div>
//                       ))
//                     ) : (
//                       <p className="text-muted mb-0">No users found</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="form-text">Selected: {newFine.users.length} user(s)</div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={isSubmitting || newFine.users.length === 0 || !newFine.amount || !newFine.fineType}
//               >
//                 {isSubmitting ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm me-2" role="status"></span>
//                     Please wait...
//                   </>
//                 ) : (
//                   "Add Fine"
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddFineModal;





import React, { useState } from "react"; 
import Swal from "sweetalert2";
import { FineService } from "../services/addNewFineService";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const AddFineModal = ({ showModal, setShowModal, users, fetchData }) => {
  const defaultFineState = {
    users: [],
    fineType: "",
    amount: "",
    date: new Date().toISOString().split("T")[0],
  };

  const [newFine, setNewFine] = useState(defaultFineState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFine((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const userId = e.target.value;
    setNewFine((prev) => ({
      ...prev,
      users: e.target.checked
        ? [...prev.users, userId]
        : prev.users.filter((id) => id !== userId),
    }));
  };

  const handleSubmitFine = async (e) => {
    e.preventDefault();
    if (newFine.users.length === 0) {
      return Swal.fire("Warning", "Select at least one user.", "warning");
    }

    setIsSubmitting(true);
    try {
      // Get allowDisallow flag
      const docRef = doc(db, "appSetupAction", "1");
      const docSnap = await getDoc(docRef);
      const allowDisallow = docSnap.exists() ? docSnap.data().allowDisallow : false;

      // ---------------------------
      // STEP 1: Prepare preview only
      // ---------------------------
      let previewResult;
      if (allowDisallow) {
        previewResult = await FineService.prepareRulewisePreview(
          newFine.users,
          newFine.fineType,
          newFine.amount,
          newFine.date,
          users
        );
      } else {
        previewResult = await FineService.prepareNormalPreview(
          newFine.users,
          newFine.fineType,
          newFine.amount,
          newFine.date
        );
      }

      const { users100, users200 } = previewResult;

      const users100Names = users100.map(id => users.find(u => u.id === id)?.userName || id);
      const users200Names = users200.map(id => users.find(u => u.id === id)?.userName || id);

      const htmlMsg = `
        <div style="margin-bottom:8px;">
          <b>${users100Names.length} user(s) will get Rs. ${newFine.amount} fine:</b><br/>
          ${users100Names.map(name => `<span style='color:#0d6efd;font-weight:bold;'>${name}</span>`).join(", ") || "<span style='color:gray'>None</span>"}
        </div>
        <div>
          <b>${users200Names.length} user(s) will get Rs. ${parseFloat(newFine.amount) * 2} fine (repeated this week):</b><br/>
          ${users200Names.map(name => `<span style='color:#dc3545;font-weight:bold;'>${name}</span>`).join(", ") || "<span style='color:gray'>None</span>"}
        </div>
      `;

      // ---------------------------
      // STEP 2: Show confirmation
      // ---------------------------
      const confirmResult = await Swal.fire({
        title: `Add a ${newFine.fineType} fine to ${newFine.users.length} user(s)?`,
        html: htmlMsg,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, add fine",
        cancelButtonText: "Cancel",
      });

      if (!confirmResult.isConfirmed) return; // User canceled → do nothing

      // ---------------------------
      // STEP 3: Actually update DB
      // ---------------------------
      if (allowDisallow) {
        await FineService.addFineRulewise(
          newFine.users,
          newFine.fineType,
          newFine.amount,
          newFine.date,
          users
        );
      } else {
        await FineService.addFineNormal(
          newFine.users,
          newFine.fineType,
          newFine.amount,
          newFine.date
        );
      }

      // ---------------------------
      // STEP 4: Refresh & reset
      // ---------------------------
      await fetchData();
      setShowModal(false);
      setNewFine(defaultFineState);

    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!showModal) return null;

  return (
    <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={handleSubmitFine}>
            <div className="modal-header">
              <h5 className="modal-title"><i className="bi bi-coin me-2"></i>Add New Fine</h5>
              <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Fine Type</label>
                <input
                  type="text"
                  className="form-control"
                  name="fineType"
                  value={newFine.fineType}
                  onChange={handleInputChange}
                  placeholder="Enter fine type"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Amount (PKR)</label>
                <div className="input-group">
                  <span className="input-group-text">Rs.</span>
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    value={newFine.amount}
                    onChange={handleInputChange}
                    placeholder="Enter amount"
                    min="0"
                    step="0.01"
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={newFine.date}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Select Users</label>
                <div className="card">
                  <div className="card-body p-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {users.length > 0 ? (
                      users.map((user) => (
                        <div key={user.id} className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${user.id}`}
                            value={user.id}
                            checked={newFine.users.includes(user.id)}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor={`user-${user.id}`}>
                            {user.userName} {user.email && `- ${user.email}`}
                          </label>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted mb-0">No users found</p>
                    )}
                  </div>
                </div>
                <div className="form-text">Selected: {newFine.users.length} user(s)</div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting || newFine.users.length === 0 || !newFine.amount || !newFine.fineType}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Please wait...
                  </>
                ) : (
                  "Add Fine"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddFineModal;